var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.hide)?_c('v-chip',_vm._b({attrs:{"color":_vm.color}},'v-chip',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.text)+" "+_vm._s(_vm._f("quotaAmount")(_vm.quota,_vm.quotaType, _vm.currencySymbol, _vm.isMileageInstance))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }